export const FCT_GUIDE_URL = 'https://prenuvo.atlassian.net/wiki/x/bYCVqQ';
